// Small pixel-art style SVG icons for things the icon pack doesn't cover
// (drives and file types). crispEdges keeps them chunky like 98's icons.

const svgProps = {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg",
  shapeRendering: "crispEdges",
};

export const HardDriveIcon = () => (
  <svg {...svgProps}>
    <rect x="2" y="11" width="28" height="13" fill="#808080" />
    <rect x="2" y="11" width="27" height="12" fill="#c0c0c0" />
    <rect x="3" y="12" width="26" height="1" fill="#fff" />
    <rect x="4" y="9" width="24" height="2" fill="#dfdfdf" />
    <rect x="5" y="16" width="14" height="4" fill="#808080" />
    <rect x="6" y="17" width="12" height="2" fill="#404040" />
    <rect x="23" y="17" width="3" height="2" fill="#00c000" />
    <rect x="2" y="24" width="28" height="1" fill="#000" />
  </svg>
);

export const FloppyIcon = () => (
  <svg {...svgProps}>
    <rect x="4" y="4" width="24" height="24" fill="#000" />
    <rect x="5" y="5" width="22" height="22" fill="#2c2c7a" />
    <rect x="9" y="5" width="14" height="9" fill="#c0c0c0" />
    <rect x="18" y="6" width="3" height="7" fill="#2c2c7a" />
    <rect x="8" y="17" width="16" height="10" fill="#fff" />
    <rect x="10" y="19" width="12" height="1" fill="#808080" />
    <rect x="10" y="22" width="12" height="1" fill="#808080" />
  </svg>
);

export const CdIcon = () => (
  <svg {...svgProps}>
    <circle cx="16" cy="16" r="12" fill="#808080" />
    <circle cx="16" cy="16" r="11" fill="#e0e0ff" />
    <path d="M16 5 A11 11 0 0 1 27 16 L16 16 Z" fill="#b8f0ff" />
    <path d="M16 27 A11 11 0 0 1 5 16 L16 16 Z" fill="#ffd8f0" />
    <circle cx="16" cy="16" r="3" fill="#fff" stroke="#808080" />
  </svg>
);

export type FileKind =
  "html" | "pdf" | "code" | "zip" | "image" | "text" | "folder";

const FILE_ACCENT: Record<FileKind, string> = {
  html: "#e44d26",
  pdf: "#c00000",
  code: "#f0c000",
  zip: "#8a5a00",
  image: "#2f8f2f",
  text: "#404040",
  folder: "#f0c000",
};

export const FileIcon = ({ kind }: { kind: FileKind }) => {
  if (kind === "folder") {
    return (
      <svg {...svgProps}>
        <rect x="3" y="8" width="11" height="3" fill="#c09000" />
        <rect x="3" y="10" width="26" height="17" fill="#806000" />
        <rect x="3" y="10" width="25" height="16" fill="#ffd84a" />
        <rect x="4" y="11" width="23" height="1" fill="#fff4b0" />
      </svg>
    );
  }
  const accent = FILE_ACCENT[kind];
  return (
    <svg {...svgProps}>
      <path d="M6 2 H21 L27 8 V30 H6 Z" fill="#000" />
      <path d="M7 3 H20 L26 9 V29 H7 Z" fill="#fff" />
      <path d="M20 3 V9 H26" fill="#c0c0c0" stroke="#000" strokeWidth="1" />
      {kind === "image" ? (
        <>
          <rect x="9" y="13" width="15" height="12" fill="#9fd4ff" />
          <path d="M9 25 L14 18 L18 22 L20 20 L24 25 Z" fill={accent} />
          <rect x="19" y="14" width="3" height="3" fill="#ffd84a" />
        </>
      ) : kind === "zip" ? (
        <>
          <rect x="14" y="3" width="4" height="22" fill="#808080" />
          <rect x="15" y="4" width="2" height="1" fill="#fff" />
          <rect x="15" y="7" width="2" height="1" fill="#fff" />
          <rect x="15" y="10" width="2" height="1" fill="#fff" />
          <rect x="13" y="20" width="6" height="6" fill={accent} />
        </>
      ) : (
        <>
          <rect x="9" y="13" width="14" height="1" fill="#808080" />
          <rect x="9" y="16" width="14" height="1" fill="#808080" />
          <rect x="9" y="19" width="10" height="1" fill="#808080" />
          <rect x="9" y="23" width="15" height="4" fill={accent} />
        </>
      )}
    </svg>
  );
};

/* ---------- toolbar glyphs ---------- */

export const BackGlyph = () => (
  <svg {...svgProps}>
    <path d="M4 16 L14 6 V12 H27 V20 H14 V26 Z" fill="#008000" stroke="#000" />
  </svg>
);

export const UpGlyph = () => (
  <svg {...svgProps}>
    <rect x="3" y="12" width="26" height="15" fill="#ffd84a" stroke="#806000" />
    <path d="M16 4 L24 12 H19 V21 H13 V12 H8 Z" fill="#008000" stroke="#000" />
  </svg>
);

export const RestoreGlyph = () => (
  <svg {...svgProps}>
    <path
      d="M8 14 A9 9 0 1 1 10 23"
      fill="none"
      stroke="#008000"
      strokeWidth="4"
    />
    <path d="M2 12 L10 6 L12 16 Z" fill="#008000" stroke="#000" />
  </svg>
);

export const DeleteGlyph = () => (
  <svg {...svgProps}>
    <path
      d="M7 5 L16 13 L25 5 L28 8 L19 16 L28 24 L25 27 L16 19 L7 27 L4 24 L13 16 L4 8 Z"
      fill="#e00000"
      stroke="#600000"
    />
  </svg>
);

export const SelectAllGlyph = () => (
  <svg {...svgProps}>
    <rect x="4" y="4" width="24" height="24" fill="#fff" stroke="#000" />
    <path d="M8 16 L14 22 L24 9" fill="none" stroke="#00007b" strokeWidth="4" />
  </svg>
);

export const PropertiesGlyph = () => (
  <svg {...svgProps}>
    <path d="M6 3 H21 L26 8 V29 H6 Z" fill="#fff" stroke="#000" />
    <rect x="9" y="11" width="13" height="2" fill="#00007b" />
    <rect x="9" y="16" width="13" height="2" fill="#808080" />
    <rect x="9" y="21" width="9" height="2" fill="#808080" />
  </svg>
);
